var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({ content: _vm.tooltipText, classes: _vm.customClass }),expression:"{ content: tooltipText, classes: customClass }"}],staticClass:"material-icons"},[_vm._v(" error ")])}
var staticRenderFns = []

export { render, staticRenderFns }